import { render, staticRenderFns } from "./ComplianceWorstPerformingBuildingsDrillDown.vue?vue&type=template&id=9182fb10&"
import script from "./ComplianceWorstPerformingBuildingsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceWorstPerformingBuildingsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports